import { render } from "./MaleRelatedQuestions.vue?vue&type=template&id=d87609f0&scoped=true"
import script from "./MaleRelatedQuestions.vue?vue&type=script&lang=js"
export * from "./MaleRelatedQuestions.vue?vue&type=script&lang=js"

import "./MaleRelatedQuestions.vue?vue&type=style&index=0&id=d87609f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d87609f0"]])

export default __exports__